import states from "../../../data/unitedStates";

const formatNumberWithCommas = (value: string) => {
  const parts = value.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (parts[1]) parts[1] = parts[1].substring(0, 2);
  return parts.join(".");
};

// const formatFloatingPoint = (value: string) => {
//   const parts = value.split(".");
//   parts[0] = formatNumberWithCommas(parts[0]);
//   if (parts[1]) parts[1] = parts[1].substring(0, 2);
//   return parts.join(".");
// };

const formatToTwoCharactersOr100 = (value: string) => {
  const num = parseInt(value);
  if (num > 100) return "100";
  return num.toString();
};

const inputFields = [
  {
    name: "loanNumber",
    label: "Loan Number",
    type: "text",
    validations: [
      { type: "required", message: "Loan Number is required" },
      {
        type: "minLength",
        value: 5,
        message: "Loan Number must be at least 5 characters",
      },
    ],
    // inputRestriction: "number",
    cleanse: (value: string) => value.replace(/\D/g, ""),
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      "Available",
      "Funded",
      "Paid Off",
      "Defaulted",
      "REO",
      "Achieved",
      "Non-Performing Loans",
      "Turn Key Investments",
    ],
  },
  {
    name: "loanType",
    label: "Loan Type",
    type: "select",
    options: [
      "ARV Purchase",
      "Purchase",
      "ARV Refinance",
      "Refinance",
      "Refinance w/Cross Collateral",
    ],
  },
  {
    name: "amountHeld",
    label: "Rehab Amount ($)",
    type: "text",
    inputRestriction: "decimal",
    displayType: "currency",
    format: formatNumberWithCommas,
    validations: [
      {
        type: "minValue",
        value: 0,
        message: "Rehab Amount must be at least $0",
      },
    ],
    showWhen: (formData: any) =>
      formData.loanType === "ARV Purchase" ||
      formData.loanType === "ARV Refinance",
  },
  {
    name: "lienPosition",
    label: "Lien Position",
    type: "select",
    options: ["1st", "2nd"],
  },
  {
    name: "loanAmount",
    label: "Loan Amount ($)",
    type: "text",
    displayType: "currency",
    inputRestriction: "decimal",
    validations: [
      { type: "required", message: "Loan Amount is required" },
      {
        type: "minValue",
        value: 1000,
        message: "Loan Amount must be at least $1,000",
      },
    ],
  },
  {
    name: "purchasePrice",
    label: "Purchase Price ($)",
    type: "text",
    inputRestriction: "decimal",
    displayType: "currency",
    validations: [{ type: "required", message: "Purchase Price is required" }],
    format: formatNumberWithCommas,
  },
  {
    name: "marketValue",
    label: "Market Value ($)",
    type: "text",
    inputRestriction: "decimal",
    displayType: "currency",
    validations: [
      { type: "required", message: "Market Value is required" },
      {
        type: "minValue",
        value: 1000,
        message: "Market Value must be at least $1,000",
      },
    ],
    format: formatNumberWithCommas,
  },
  {
    name: "downPayment",
    label: "Down Payment ($)",
    type: "text",
    inputRestriction: "decimal",
    displayType: "currency",
    validations: [{ type: "required", message: "Down Payment is required" }],
    format: formatNumberWithCommas,
  },
  {
    name: "ltv",
    label: "ARV LTV (%)",
    type: "text",
    validations: [
      { type: "required", message: "ARV LTV is required" },
      {
        type: "range",
        min: 0,
        max: 100,
        message: "ARV LTV must be between 0 and 100",
      },
    ],
    format: formatNumberWithCommas,
  },
  {
    name: "interestRate",
    label: "Rate Of Return (%)",
    type: "text",
    validations: [
      { type: "required", message: "Rate Of Return is required" },
      {
        type: "range",
        min: 0,
        max: 100,
        message: "Rate Of Return must be between 0 and 100",
      },
    ],
    format: formatToTwoCharactersOr100,
  },
  {
    name: "loanTerm",
    label: "Loan Term (months)",
    type: "text",
    validations: [
      { type: "required", message: "Loan Term is required" },
      {
        type: "range",
        min: 1,
        max: 60,
        message: "Loan Term must be between 1 and 60 months",
      },
    ],
    format: formatNumberWithCommas,
  },
  { name: "useOfProceeds", label: "Use of Proceeds", type: "text" },
  { name: "exitStrategy", label: "Exit Strategy", type: "text" },
  {
    name: "maturityDate",
    label: "Maturity Date",
    type: "date",
    validations: [{ type: "required", message: "Maturity Date is required" }],
  },
  {
    name: "averageCredit",
    label: "Average Credit",
    type: "text",
    inputRestriction: "number",
    format: (value: string) => value.slice(0, 3),
    validations: [
      { type: "required", message: "Average Credit is required" },
      {
        type: "range",
        min: 0,
        max: 850,
        message: "Average Credit must be between 300 and 850",
      },
    ],
  },
  {
    name: "averageBankBalance",
    label: "Average Bank Balance ($)",
    type: "text",
    displayType: "currency",
    validations: [
      { type: "required", message: "Average Bank Balance is required" },
    ],
    inputRestriction: "decimal",
    format: formatNumberWithCommas,
  },

  {
    name: "propertyType",
    label: "Property Type",
    type: "select",
    options: ["Single Family", "Duplex", "Multi Unit 3+", "Townhouse", "Condo"],
  },
  {
    name: "streetNumber",
    label: "Street Address",
    type: "text",
    validations: [{ type: "required", message: "Street Address is required" }],
  },
  {
    name: "city",
    label: "City",
    type: "text",
    validations: [{ type: "required", message: "City is required" }],
  },
  { name: "state", label: "State", type: "select", options: states },
  {
    name: "postalCode",
    label: "Postal Code",
    type: "text",
    inpputRestriction: "number",
    // cleanse: (value: string) => cleanseNumber(value),
  },
  {
    name: "numberOfBedrooms",
    label: "Number Of Bedrooms",
    type: "text",
    inputRestriction: "number",
    validations: [
      { type: "required", message: "Number Of Bedrooms is required" },
      {
        type: "range",
        min: 0,
        max: 20,
        message: "Number Of Bedrooms must be between 0 and 20",
      },
    ],
    // cleanse: (value: string) => cleanseNumber(value),
  },
  {
    name: "numberOfBathrooms",
    label: "Number Of Bathrooms",
    type: "text",
    inputRestriction: "number",
    validations: [
      { type: "required", message: "Number Of Bathrooms is required" },
      {
        type: "range",
        min: 0,
        max: 20,
        message: "Number Of Bathrooms must be between 0 and 20",
      },
    ],
  },
  {
    name: "squareFeet",
    label: "Square Feet",
    type: "text",
    inputRestriction: "number",
    validations: [
      { type: "required", message: "Square Feet is required" },
      {
        type: "range",
        min: 0,
        max: 100000,
        message: "Square Feet must be between 0 and 100,000",
      },
    ],
    format: formatNumberWithCommas,
  },
  {
    name: "isPerforming",
    label: "Is this loan performing?",
    type: "checkbox",
  },
  {
    name: "repeatBorrower",
    label: "Is this a repeat borrower?",
    type: "checkbox",
  },
  {
    name: "paidOffPreviously",
    label: "Has the borrower paid off Cogo previously?",
    type: "checkbox",
  },
  { name: "loanPackagePdf", label: "Loan Package PDF", type: "file" },
  // {
  //   name: "propertyDetailsExcel",
  //   label: "Property Details Excel",
  //   type: "file",
  // },
];

export default inputFields;
